import { render, staticRenderFns } from "./WrongMarginAppointments.vue?vue&type=template&id=5d8933fc&scoped=true&"
import script from "./WrongMarginAppointments.vue?vue&type=script&lang=js&"
export * from "./WrongMarginAppointments.vue?vue&type=script&lang=js&"
import style0 from "./WrongMarginAppointments.vue?vue&type=style&index=0&id=5d8933fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8933fc",
  null
  
)

export default component.exports